import React from 'react';

interface ICheckmarkProps {
  className?: string;
}

export const Checkmark: React.FC<ICheckmarkProps> = React.memo(({ className }) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_6000_57000)">
      <path d="M2.04949 9.10336C1.86603 8.89697 1.55 8.87838 1.3436 9.06184C1.13721 9.2453 1.11862 9.56134 1.30208 9.76773L5.30208 14.2677C5.49321 14.4827 5.82591 14.4925 6.02934 14.2891L16.5293 3.7891C16.7246 3.59384 16.7246 3.27726 16.5293 3.08199C16.3341 2.88673 16.0175 2.88673 15.8222 3.08199L5.6972 13.207L2.04949 9.10336Z" fill="white" />
      <path d="M2.04949 9.10336C1.86603 8.89697 1.55 8.87838 1.3436 9.06184C1.13721 9.2453 1.11862 9.56134 1.30208 9.76773L5.30208 14.2677C5.49321 14.4827 5.82591 14.4925 6.02934 14.2891L16.5293 3.7891C16.7246 3.59384 16.7246 3.27726 16.5293 3.08199C16.3341 2.88673 16.0175 2.88673 15.8222 3.08199L5.6972 13.207L2.04949 9.10336Z" fill="url(#paint0_linear_6000_57000)" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_6000_57000" x1="1.17578" y1="2.93555" x2="12.1818" y2="17.7698" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3D07D5" />
        <stop offset="0.450521" stopColor="#213AD5" />
        <stop offset="1" stopColor="#0078D4" />
      </linearGradient>
      <clipPath id="clip0_6000_57000">
        <rect width="16" height="16" fill="white" transform="translate(0.675781 0.935547)" />
      </clipPath>
    </defs>
  </svg>
));
